import {
  CACHE_HOME_MEDIA_MESSAGE_TYPE,
  EVICT_HOME_MEDIA_MESSAGE_TYPE,
  HOME_MEDIA_REGISTERED_MESSAGE_TYPE,
} from '@/constant/prefetch-messages'

const HOME_MEDIA_REGISTRATION_TIMEOUT_MS = 50

type HomeMediaRegistration = {
  images: readonly string[]
  videos: readonly string[]
}

// opaque 响应看不到真实 HTTP status；媒体元素确认加载失败后通知 SW 删除该 URL
// 的所有持久缓存变体。驱逐失败保持 best-effort，下次错误仍会继续尝试。
export const evictHomeMediaFromPersistentCache = (url: string): void => {
  if (!url) return
  try {
    if (typeof navigator === 'undefined') return
    navigator.serviceWorker?.controller?.postMessage({
      type: EVICT_HOME_MEDIA_MESSAGE_TYPE,
      url,
    })
  } catch {
    // 缓存驱逐是错误恢复增益，不影响媒体原有 onError 路径。
  }
}

// 只登记精确 URL，不让 SW 再触发一轮预热；调用方收到确认后继续用真实
// Image/Video 元素发请求，从而保留正确的媒体请求上下文。
export const registerHomeMediaForPersistentCache = (
  media: HomeMediaRegistration
): Promise<void> => {
  if (media.images.length === 0 && media.videos.length === 0) {
    return Promise.resolve()
  }

  try {
    if (
      typeof navigator === 'undefined' ||
      typeof MessageChannel === 'undefined'
    ) {
      return Promise.resolve()
    }
    const worker = navigator.serviceWorker?.controller
    if (!worker) return Promise.resolve()

    return new Promise((resolve) => {
      const channel = new MessageChannel()
      let settled = false
      const finish = (): void => {
        if (settled) return
        settled = true
        clearTimeout(timeoutId)
        channel.port1.onmessage = null
        channel.port1.onmessageerror = null
        channel.port1.close()
        resolve()
      }

      channel.port1.onmessage = (event) => {
        const message = (event.data || {}) as { type?: string }
        if (message.type === HOME_MEDIA_REGISTERED_MESSAGE_TYPE) finish()
      }
      channel.port1.onmessageerror = finish
      const timeoutId = setTimeout(finish, HOME_MEDIA_REGISTRATION_TIMEOUT_MS)

      try {
        worker.postMessage(
          {
            type: CACHE_HOME_MEDIA_MESSAGE_TYPE,
            images: [...media.images],
            videos: [...media.videos],
            prewarm: false,
          },
          [channel.port2]
        )
      } catch {
        finish()
      }
    })
  } catch {
    return Promise.resolve()
  }
}
